import { BlocksIconPdf } from 'blocks-nextjs/blocks-web-components/components/icon/icons/pdf';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconPdf = createComponent({ react: React, tagName: 'cat-icon-pdf', elementClass: BlocksIconPdf });
